import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { forwardRef, useImperativeHandle, useRef } from 'react';
import { useOccContext } from '../../../context/occ/hooks/use-occ-context';
import { Icon } from '../../icon/icon';
import { defaultButtonColor } from '../types/color';
import { isButtonIconOnlyProps, isButtonWithChildrenProps, isButtonWithLabelProps } from '../types/props';
import { defaultButtonSize } from '../types/size';
const b = bemClassBuilder('v-button');
/**
 * Renders a button.
 */
const ButtonBase = (props, forwardedRef) => {
    const { assets: occAssets } = useOccContext();
    const buttonRef = useRef(null);
    const { disabled, type, tabIndex, iconName, iconPosition, color, size, loading, loadingIconName, className, onClick } = props;
    const iconOnly = isButtonIconOnlyProps(props) ? props.iconOnly : false;
    const modifiers = {
        color: color || defaultButtonColor,
        size: size || defaultButtonSize,
        loading: loading || false,
        iconOnly
    };
    const buttonClass = b.block(modifiers, className);
    const handleClick = event => {
        if (disabled || loading) {
            return;
        }
        onClick === null || onClick === void 0 ? void 0 : onClick(event);
    };
    useImperativeHandle(forwardedRef, () => ({
        focus: () => {
            var _a;
            (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }));
    const children = isButtonWithChildrenProps(props) ? props.children : undefined;
    const ariaLabel = isButtonWithLabelProps(props) ? props.label : undefined;
    const label = !iconOnly && isButtonWithLabelProps(props) ? props.label : undefined;
    return (_jsx("button", { className: buttonClass, type: type, disabled: disabled, onClick: handleClick, tabIndex: disabled ? -1 : tabIndex, "aria-label": iconOnly ? ariaLabel : undefined, form: props.formId, ref: buttonRef, children: _jsxs("div", { className: b.element('content', { position: iconPosition }), children: [iconName && _jsx(Icon, { className: b.element('icon', { position: iconPosition }), name: iconName }), !iconOnly && label && label.length > 0 && _jsx("span", { className: b.element('label'), children: label }), children, loading && (_jsx(Icon, { className: b.element('loading-icon'), name: loadingIconName || occAssets.loadingIconName }))] }) }));
};
export const ButtonUi = observer(forwardRef(ButtonBase));
ButtonUi.displayName = 'ButtonUi';
//# sourceMappingURL=ui.js.map